<template>
  <div class="swipe-item">
    <slot></slot>
  </div>
</template>

<script>
  export default {
    name: 'swipe-item',
    mounted() {
      this.$parent && this.$parent.swipeItemCreated(this);
    },
    destroyed() {
      this.$parent && this.$parent.swipeItemDestroyed(this);
    }
  };
</script>
<style lang="less">

</style>



// WEBPACK FOOTER //
// src/components/swiper/item.vue